export default __webpack_public_path__ + "static/media/(21).e772b87b.JPG";